{
  "helpMessage": "<h3>कोई सवाल है?</h3>\n<p>हमारी टीम आपकी मदद करने के लिए उपलब्ध है - कॉल करें:<br/><a><strong>☎️ {{phone}}</strong></a> (फिर दबाएं <strong>Option 2</strong>)<br/>सोमवार से शुक्रवार, सुबह 8 से शाम 5 बजे तक।</p>",
  "title": "निमंत्रण अमान्य है"
}
